class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.descriptionEl = null;
    this.toggleButton = null;
    this.maxHeight = 10;
    this.isExpanded = false;
  }

  connectedCallback() {
    // Wait for next frame to ensure content is rendered
    requestAnimationFrame(() => {
      this.init();
      // Also check after images load
      this.waitForImages();
    });
  }

  waitForImages() {
    const images = this.querySelectorAll('img');
    if (images.length === 0) return;
    
    let loadedCount = 0;
    images.forEach(img => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            this.checkAndUpdate();
          }
        });
        img.addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            this.checkAndUpdate();
          }
        });
      }
    });
    
    if (loadedCount === images.length) {
      this.checkAndUpdate();
    }
  }

  init() {
    this.descriptionEl = this.querySelector('.collection-description__content');
    this.toggleButton = this.querySelector('.collection-description__toggle');
    
    if (!this.descriptionEl || !this.toggleButton) return;

    this.maxHeight = parseInt(this.dataset.maxHeight) || 150;
    this.checkAndUpdate();
    
    this.toggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });
  }

  checkAndUpdate() {
    if (!this.descriptionEl || !this.toggleButton) return;
    
    const fullHeight = this.descriptionEl.scrollHeight;
    
    if (fullHeight <= this.maxHeight) {
      // Content doesn't need truncation, hide toggle
      this.toggleButton.style.display = 'none';
      this.descriptionEl.style.maxHeight = 'none';
      this.descriptionEl.style.overflow = 'visible';
      return;
    }

    // Show toggle button
    this.toggleButton.style.display = 'inline-block';
    
    // Set initial collapsed state if not already expanded
    if (!this.isExpanded) {
      this.descriptionEl.style.maxHeight = `${this.maxHeight}px`;
      this.descriptionEl.style.overflow = 'hidden';
      this.descriptionEl.style.transition = 'max-height 0.3s ease';
    }
    
    this.updateButtonText();
  }

  toggle() {
    if (!this.descriptionEl || !this.toggleButton) return;
    
    this.isExpanded = !this.isExpanded;
    const fullHeight = this.descriptionEl.scrollHeight;
    
    if (this.isExpanded) {
      this.descriptionEl.style.maxHeight = `${fullHeight}px`;
      this.descriptionEl.style.overflow = 'visible';
    } else {
      this.descriptionEl.style.maxHeight = `${this.maxHeight}px`;
      this.descriptionEl.style.overflow = 'hidden';
    }
    
    this.updateButtonText();
  }

  updateButtonText() {
    if (!this.toggleButton) return;
    const readMoreText = this.dataset.readMoreText || 'Read more';
    const readLessText = this.dataset.readLessText || 'Read less';
    this.toggleButton.textContent = this.isExpanded ? readLessText : readMoreText;
    this.toggleButton.setAttribute('aria-expanded', this.isExpanded);
  }
}

customElements.define('read-more', ReadMore);
